import React from 'react';
import { Grid, Box } from '@mui/material';

type Props = {
  label: string;
  children?: React.ReactNode;
};

const boxStyle = { padding: '5px 0px 5px 0px', borderBottom: '1px solid #b1b4b5', textAlign: 'center' };
const SmallPlanRegistryForm: React.FC<Props> = ({ label, children }) => {
  return (
    <Grid item xs={12}>
      <Box sx={boxStyle}>
        <Grid textAlign="left" pl={2} pb={1}>
          {label}
        </Grid>
        <Grid>{children}</Grid>
      </Box>
    </Grid>
  );
};
export default SmallPlanRegistryForm;
